import { put, takeEvery } from 'redux-saga/effects';

import { lists as Lists } from '../common/lists';

import * as DocType from '../constants/constant_doc_types';

export function* fetchProductTypeListSaga(feathersApp) {
  yield takeEvery("FETCH_LIST_PRODUCT_TYPES", callFetchProductTypeList, feathersApp);
}
function* callFetchProductTypeList(feathersApp, action) {
  const { intl } = action;
  const list = Lists.ITEM_TYPE(intl).map(obj => {
    return {
      doc_type: DocType.ITEMTYPE,
      id: obj.value,
      name: obj.name
    };
  });
  yield put({ type: 'FETCH_LIST_DATA_ARRAY_DONE', rows: list })
}

